import {enableMapSet, enablePatches, setAutoFreeze} from 'immer';

// enable these globally for immer
setAutoFreeze(false);
enableMapSet();
enablePatches();
